<template>
    <div id="pdf" class="">
        <v-toolbar dense color="indigo" dark>
            <v-toolbar-title> PDF </v-toolbar-title>
            <v-spacer />
            <v-btn small @click="closedialog" light>
                <v-icon color="error"> mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
        <!-- <PDFViewer
      v-bind="{url}"
      @document-errored="onDocumentErrored"
      @close="closedialog($event)"
      >
      <PDFUploader
        v-if="enableUploader"
        :documentError="documentError"
        @updated="urlUpdated"
        slot="header"
        class="header-item"
        
        />
    </PDFViewer> -->
        <!--<bsd-pdf ref="pdf" @on-success="load" @on-pagerender="pagerender" @on-scroll="scroll" :filePath="selectedPdf">

    <template slot="header">
      <v-btn small :disabled="currentNum<=1" @click="pre">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <input class="ml-1 mr-1" type="number" style="min-width:40px;background-color:white;" :min="1" :max="pageNum" v-model.number="currentNum" @change="pageChange(currentNum)">
      <v-btn small :disabled="currentNum>=pageNum" @click="next">
        <v-icon>mdi-arrow-right</v-icon>
      </v-btn>
      <v-btn small @click.prevent.stop="zoomIn" class="icon ml-1 " :disabled="isDisabled">
      <v-icon >mdi-magnify-plus-outline
</v-icon>
    </v-btn>
    <v-btn small @click.prevent.stop="zoomOut" class="icon ml-1" :disabled="isDisabled">
      <v-icon>mdi-magnify-minus-outline</v-icon>
    </v-btn>
       <v-btn small @click.prevent.stop="$refs.pdf.changeScale('page-actual')" class="icon ml-1" :disabled="isDisabled">
      <v-icon>
        mdi-arrow-expand-all

      </v-icon>
    </v-btn>
    <v-btn small @click.prevent.stop="$refs.pdf.changeScale('page-fit')" class="icon ml-1" :disabled="isDisabled">
      <v-icon>
        mdi-arrow-collapse-all
      </v-icon>
    </v-btn>

       <v-btn  small @click="print" class="icon ml-1 hidebutton " :disabled="isDisabled">
      <v-icon>
        mdi-printer
      </v-icon>
    </v-btn>
   
    <v-btn small @click.prevent.stop="downloadPDF" class="icon ml-1" :disabled="isDisabled">
      <v-icon>
        mdi-download
      </v-icon>
    </v-btn>
    <v-btn style="float:right;" @click="closedialog" small>
        <v-icon>
          mdi-close
        </v-icon>
      </v-btn>
    </template>
  </bsd-pdf>-->
        <iframe style="height: 70vh; width: 85vw" :src="selectedPdf + '#sidebar=0'" />
    </div>
</template>

<script>
// import PDFUploader from '../PDF/PDFUploader.vue'
// import PDFViewer from '../PDF/PDFViewer.vue'
//import bsdPdf from 'bsd-pdf'
//import 'bsd-pdf/package/bsd-pdf.css'

export default {
    props: ["selectedPdf"],
    components: {
        //bsdPdf,
    },
    data() {
        return {
            pageNum: null,
            scale: 1.5,
            currentNum: 1,
            pageLoaded: 0,
            isLoading: true,
            page: null,
            pageCount: 1,
            showAllPages: true,
            pdf: null,
            url: this.selectedPdf,
            name: this.selectedPdf, //change which pdf file loads
            path: "lib/web/viewer.html",
        };
    },

    methods: {
        downloadPDF() {
            const linkSource = `${this.url}`;
            const downloadLink = document.createElement("a");
            const fileName = "download.pdf";
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
        },
        fileChanged() {
            this.file = this.src;
        },
        load(val) {
            this.pageNum = val;
        },
        zoomIn() {
            this.scale += 0.25;
            this.$refs.pdf.changeScale(this.scale);
            console.log("this.scale :>> ", this.scale);
        },
        zoomOut() {
            if (this.scale > 0.25) {
                this.scale -= 0.25;
                this.$refs.pdf.changeScale(this.scale);
                console.log("this.scale :>> ", this.scale);
            }
        },
        setScale() {
            this.$refs.pdf.changeScale(this.scale);
        },
        scroll(val) {
            this.currentNum = val;
        },
        pagerender(val) {
            this.pageLoaded = val;
        },
        pre() {
            this.$refs.pdf.prePage();
        },
        next() {
            this.$refs.pdf.nextPage();
        },
        pageChange(val) {
            this.$refs.pdf.goToPage(val);
        },
        print() {
            this.$refs.pdf.printFile();
        },
        closedialog() {
            this.$emit("closedialog");
        },
        urlUpdated() {
            this.documentError = undefined;
            this.url = "http://www.africau.edu/images/default/sample.pdf";
        },
        onDocumentErrored(e) {
            this.documentError = e.text;
        },
        afterCreatedHandler(pdfApp) {
            pdfApp.isViewerEmbedded = true;
        },
        openHandler(pdfApp) {
            window._pdfApp = pdfApp;
        },
        pagesRenderedHandler(pdfApp) {
            setTimeout(
                () => (pdfApp.pdfViewer.currentScaleValue = "page-height")
            );
        },
        handleDocumentRender() {
            this.isLoading = false;
            this.pageCount = this.$refs.pdfRef.pageCount;
        },
        handlePasswordRequest(callback, retry) {
            callback(prompt(retry ? "Enter password again" : "Enter password"));
        },
    },
    mounted() {
        /*console.log("this.selectedPdf :>> ", this.selectedPdf);
        var binary_string = window.atob(this.selectedPdf.split(",")[1]);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        this.pdf = bytes.buffer;
        console.log("this.pdf :>> ", this.pdf);*/
    },
};
</script>

<style lang="css">
#pdf {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #62637a;
}
label.form {
    color: white;
    font-family: Monaco, "Courier New", Courier, monospace;
    font-weight: bold;
    margin-bottom: 2em;
    display: block;
}
input {
    padding: 0.45em;
    font-size: 1em;
}
.error {
    border: 1px solid red;
    background: pink;
    color: red;
    padding: 0.5em 3em;
    display: inline;
}

a.icon {
    cursor: pointer;
    display: block;
    border: 1px #333 solid;
    background: white;
    color: #333;
    font-weight: bold;
    padding: 0.25em;
    width: 1em;
    height: 1em;
    font-size: 1.5em;
}

.box-shadow {
    box-shadow: 0 15px 30px 0 rgba(0, 0, 0, 0.11),
        0 5px 15px 0 rgba(0, 0, 0, 0.08);
}
.overflow-hidden {
    overflow: hidden;
}
.pdf-catalogue {
    display: none !important;
}
.pdf-container {
    background-color: black !important;
}
.pdf-header {
    background-color: #3f51b5;
}
@media print {
    #pdf {
        margin: 0;
        padding: 0;
    }
}
</style>
